var CryptoJS = require("crypto-js");

export function SHA1(data){
    //APP AES
    const hash = CryptoJS.SHA1(data);
    // 将加密后的结果转换为十六进制字符串
    const hashInHex = hash.toString(CryptoJS.enc.Hex).toLowerCase();
    return hashInHex;
}


// WEBPACK FOOTER //
// ./src/utils/sha1.js